<template>
    <AvisOffre/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AvisOffre from "@/components/Offre/AvisOffre.vue";

    export default defineComponent({
      name: "AvisOffrePage",
      components: {
        
        AvisOffre,
      },
    });
  </script>